// src/contexts/LanguageContext.js
import { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ar'); // Default to English

  // Translation dictionary
  const translations = {
    en: {
      header: {
        home: "Home",
        about: "About Us",
        our_services:"Our Service",
        our_works:"Our Works",
        plag:"Plag",
        btn_contact_us_text:"Contact Us",
        btn_sevice_request:"Service Request"
      },
      home: {
        welcome: "Welcome to our site!",
        home_img_description:"Technology is our world By merging technology with marketing, we innovate shared solutions and deliver a uniquely crafted blend of creativity",
        btn_contact_us_text:"Contact Us",
        btn_how_are_we_text:"Who Are",
        about_section:{
          section_title:" Discover MP Tech  ",
          section_sub_title:"From vision to real 🚀",
          section_description:"We transcend all technical and marketing boundaries to break through the skies and reach the horizons of our clients, fulfilling their desires to see creativity embodied and their marketing and technical goals achieved with dedication and impressive professionalism. At mtech, we believe that the foundation of strength and the essence of perseverance within the team lie in its spirit, capable of succeeding and overcoming challenges, turning them into a launchpad for pride in the results, achieving customer satisfaction, and meeting their needs with the most advanced and rare means.",
          btn_learn_more:"Learn More"
        },
        our_service_section:{
          section_title:"Our Service",
          section_sub_title:"Solutions designed for your success ✅",
          section_description:"We excel in delivering quality, rapid execution, competitive pricing, and outstanding customer service. Acquiring these exceptional competencies was no small endeavor, but through united efforts, we’ve harmonized expertise to provide the highest standard of service.",
          btn_sevice_request:"Service Request",
        },
        our_works_section:{
          section_title:"Our Works",
          section_sub_title:"Our Innovations in the Digital World",
          section_description:"Discover our work blending innovation and technology—delivering custom digital solutions that inspire and future-proof businesses.",
        }
        ,Customer_section:{
          section_title:"Success Partners",
          section_sub_title:"Partners in our Digital Journey",
        }
      },
      contact:{
        section_title:"Contact Us",
          section_sub_title:"We are waiting your Message any time",
          section_description:"Got a question or an idea? We're here to help! Let’s turn your vision into reality – contact us now!",
      },
      contact_form:{
        title:"Recive your messages with all love ",
        name_label:"Your Full Name",
        name_placeHolder:"Write your name here...",
        email_label:"Email",
        email_placeHolder:"Write your email here...",
        phone_label:"Phone Number",
        phone_placeHolder:"Write your phone number here...",
        message_label:"Message",
        message_placeHolder:"Write your message here...",
        send_btn:"Send"
      },
      footer:{
        description:"At our company, we deliver cutting-edge digital and technological solutions that elevate your presence in the digital world. We craft innovative marketing strategies to achieve your goals and expand your reach to the right audience. With us, your ideas transform into tangible reality—executed with unmatched quality and efficiency.",
        contact_title:"Contact Information",
        address:"Jeddah-Almadinah Street",
        phone:"557380850",
        email:"info@mptech.com.sa",
        all_right:"All rights reserved to MP TECH "
      },
      aboutUs_page:{
        section_title:"MP TECH ",
          section_sub_title:"Technology Is Our World",
          section_description:"We transcend all technical and marketing boundaries to break through the skies and reach the horizons of our clients, fulfilling their desires to see creativity embodied and their marketing and technical goals achieved with dedication and impressive professionalism. At mtech, we believe that the foundation of strength and the essence of perseverance within the team lie in its spirit, capable of succeeding and overcoming challenges, turning them into a launchpad for pride in the results, achieving customer satisfaction, and meeting their needs with the most advanced and rare means.",
          btn_service_more:"Our Service"
      },
      our_task:{
        section_title:"Our Task And Department",
        section_description:"Driving Tech Excellence: Our Team, Your Solutions, Shared Success."
      }
    },
    ar: {
      header: {
        home: "الرئيسية",
        about: "من نحن",
        our_services:"خدماتنا",
        our_works:"اعمالنا",
        plag:"المدونة",
        btn_contact_us_text:"تواصل معنا",
        btn_sevice_request:"اطلب الخدمة"
      },
      home: {
        welcome: "مرحبا بكم في موقعنا!",
        home_img_description:"بدمج التقنية مع التسويق ابتكرنا حلول مشتركة وقدمنا مزيجًا متفردًا من الإبداع.",
        btn_contact_us_text:"تواصل معنا",
        btn_how_are_we_text:"من نحن",
        about_section:{
          section_title:" تعرف على  MPTech",
          section_sub_title:"من الرؤية إلى الواقع 🚀",
          section_description:"نتخطى كافة الحدود التقنية والتسويقية لنخترق عنان السماء ونصل إلى آفاق العميل ورغباته في رؤية تجسيد الإبداع وتحقيق أهدافه التسويقية والتقنية بتفاني ومهنية مبهرة، نؤمن في mptech  أن أساس القوة وجوهر المثابرة في الفريق  يكمن في روحه القادرة على النجاح وكسب التحديات لنحولها إلى انطلاقة الفخر بالنتائج والوصول لرضى العميل وتلبية احتياجاته بأندر الوسائل المتقدمة.",
        btn_learn_more:"تعرف المزيد",
        },
        our_service_section:{
          section_title:"خدماتنا",
          section_sub_title:"حلول مصممة لنجاحك ✅",
          section_description:"تتميز خدماتنا بالجودة وسرعة التنفيذ والتنافسية بالأسعار وحسن التعامل مع العملاء، وتحصيل هذه المهارات الفذة لم يكن بالأمر الهين، لكننا استطعنا تجميع ولم شمل الجهود لنقدم أفضل مستوى من الخدمة",
          btn_sevice_request:"اطلب الخدمة",
        },
        our_works_section:{
          section_title:"مشاريعنا",
          section_sub_title:"إبداعاتنا في العالم الرقمي ",
          section_description:"استكشف أعمالنا التي تجمع بين الابتكار والتقنية، حيث نقدم حلولاً رقمية مخصصة تلهم وتحوّل الأعمال نحو المستقبل",
        },
        Customer_section:{
          section_title:"شركاء النجاح",
          section_sub_title:"شركاء في رحلتنا الرقمية",
        },
      },
      contact:{
        section_title:"تواصل معنا",
          section_sub_title:"ننتظر تواصلك معنا في اي وقت ",
          section_description:"لديك استفسار أو فكرة؟ نحن هنا لمساعدتك، لتحويل أفكارك إلى حقيقة ملموسة تواصل معنا الآن",
      },
      contact_form:{
        title:"نستقبل رسائلكم بكل حب ",
        name_label:"اسمك الكامل",
        name_placeHolder:"اكتب اسمك هنا...",
        email_label:"الايميل",
        email_placeHolder:"اكتب ايميلك هنا...",
        phone_label:"رقم الجوال",
        phone_placeHolder:"اكتب رقم جوالك هنا...",
        message_label:"الرسالة",
        message_placeHolder:"اكتب رسالتك هنا...",
        send_btn:"ارسال"
      },
      footer:{
        description:"نقدم في شركتنا أحدث الحلول التقنية والتسويقية لتعزيز تواجدك الرقمي المليء بالإبداع، نبتكر استراتيجيات تسويقية تؤثر على العالم، وتوصلك إلى الجمهور المناسب في كل مرة، أنضم إلينا لتنفيذ سلسلة أفكارك بخبرة وكفاءة.",
        contact_title:"معلومات التواصل",
        address:"جدة- طريق المدينة",
        phone:"557380850",
        email:"info@mptech.com.sa",
        all_right:"جميع الحقوق محفوظة  MP TECH "
      },
      
      aboutUs_page:{
        section_title:" MP TECH",
          section_sub_title:"التقنية عالمنا",
          section_description:"نتخطى كافة الحدود التقنية والتسويقية لنخترق عنان السماء ونصل إلى آفاق العميل ورغباته في رؤية تجسيد الإبداع وتحقيق أهدافه التسويقية والتقنية بتفاني ومهنية مبهرة، نؤمن في mtech أن أساس القوة وجوهر المثابرة في الفريق يكمن في روحه القادرة على النجاح وكسب التحديات لنحولها إلى انطلاقة الفخر بالنتائج والوصول لرضى العميل وتلبية احتياجاته بأندر الوسائل المتقدمة.",
          btn_service_more:"خدماتنا"
      },
      our_task:{
        section_title:"مهامنا واقسامنا",
        section_description:"نحو التميز التقني: فريقنا، حلولنا، نجاحك"
      }
    }
  };

  // Translation function
  const t = (key) => {
    const keys = key.split('.');
    return keys.reduce((obj, k) => obj?.[k], translations[language]) || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for easy access
export const useLanguage = () => useContext(LanguageContext);